import { render } from "./CLoading.vue?vue&type=template&id=5ea88bcc&scoped=true"
const script = {}

import "./CLoading.vue?vue&type=style&index=0&id=5ea88bcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea88bcc"]])

export default __exports__